/* NotificationBanner
 * Reusable banner system for site-wide notifications.
 * Requires: notification-banner.css
 *
 * Usage:
 *   NotificationBanner.show({ message: 'Something happened', type: 'error' });
 *   NotificationBanner.show({ message: 'Added!', type: 'success', duration: 3000 });
 *   NotificationBanner.clear();
 *
 * Types: 'error' | 'warning' | 'success' | 'info'
 * Options:
 *   message  {string}  - Text to display (required)
 *   type     {string}  - Visual style (default: 'info')
 *   duration {number}  - Auto-dismiss ms, 0 = persistent (default: 5000)
 *   id       {string}  - Unique ID to prevent duplicates (default: 'db-notification')
 */

if (!window.NotificationBanner) {

  const NotificationBanner = {

    show({ message, type = 'info', duration = 5000, id = 'db-notification' } = {}) {
      if (!message) return;

      const existing = document.getElementById(id);
      if (existing) existing.remove();

      const el = document.createElement('div');
      el.id = id;
      el.className = `db-notification db-notification--${type}`;
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'assertive');

      const text = document.createElement('span');
      text.textContent = message;
      el.appendChild(text);

      const close = document.createElement('button');
      close.className = 'db-notification__close';
      close.setAttribute('aria-label', 'Dismiss');
      close.textContent = '×';
      close.addEventListener('click', () => el.remove());
      el.appendChild(close);

      document.body.appendChild(el);

      if (duration > 0) {
        setTimeout(() => { if (el.parentNode) el.remove(); }, duration);
      }

      return el;
    },

    clear(id = 'db-notification') {
      const el = document.getElementById(id);
      if (el) el.remove();
    }

  };

  window.NotificationBanner = NotificationBanner;

} // end guard
